import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { PrescriptionData } from '../Prescription.ts';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function useGetPrescriptions(id?: string) {
    const patientId = useIdFromRoute() || id;
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.prescription, patientId],
        queryFn: async () => {
            const result: PrescriptionData = await PrescriptionApi.getPrescriptions(patientId!);
            return new PrescriptionData(result);
        },
        enabled: !!patientId,
    });
}
